import { toURLSearchParams } from '@wix/metro-runtime';
import { serializer } from '@wix/metro-runtime/ambassador';
import { resolveUrl } from '@wix/metro-runtime';
var _backup = {
    requestedDate: 'google.protobuf.Timestamp',
    startedDate: 'google.protobuf.Timestamp',
    finishedDate: 'google.protobuf.Timestamp',
    deletedDate: 'google.protobuf.Timestamp',
};
var _cancelBackupRequest = {};
var _cancelBackupResponse = {};
var _createBackupRequest = {};
var _createBackupResponse = { backup: '_backup' };
var _deleteBackupRequest = {};
var _deleteBackupResponse = {};
var _listBackupsRequest = {};
var _listBackupsResponse = { backups: '_backup' };
var _listRestorationsRequest = {};
var _listRestorationsResponse = { restorations: '_restoration' };
var _restoration = {
    requestedDate: 'google.protobuf.Timestamp',
    startedDate: 'google.protobuf.Timestamp',
    finishedDate: 'google.protobuf.Timestamp',
    backup: '_backup',
};
var _restoreBackupRequest = {};
var _restoreBackupResponse = { restoration: '_restoration' };
var _restorePartialBackupRequest = {};
function resolveComWixpressDstoreApiBackupV2BackupServiceUrl(opts) {
    var domainToMappings = {
        'www._base_domain_': [
            {
                srcPath: '/_api/data/backups',
                destPath: '/api/v1/backups',
            },
            {
                srcPath: '/_api/data/v2/backups',
                destPath: '/v2/backups',
            },
        ],
        'manage._base_domain_': [
            {
                srcPath: '/_api/data/backups',
                destPath: '/api/v1/backups',
            },
            {
                srcPath: '/_api/data/v2/backups',
                destPath: '/v2/backups',
            },
        ],
        'editor._base_domain_': [
            {
                srcPath: '/_api/data/backups',
                destPath: '/api/v1/backups',
            },
            {
                srcPath: '/_api/data/v2/backups',
                destPath: '/v2/backups',
            },
        ],
        'blocks._base_domain_': [
            {
                srcPath: '/_api/data/backups',
                destPath: '/api/v1/backups',
            },
            {
                srcPath: '/_api/data/v2/backups',
                destPath: '/v2/backups',
            },
        ],
        'create.editorx': [
            {
                srcPath: '/_api/data/backups',
                destPath: '/api/v1/backups',
            },
            {
                srcPath: '/_api/data/v2/backups',
                destPath: '/v2/backups',
            },
        ],
        'www.wixapis.com': [
            {
                srcPath: '/wix-data/v1/backups',
                destPath: '/api/v1/backups',
            },
            {
                srcPath: '/wix-data/v2/backups',
                destPath: '/v2/backups',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
/**
 * Creates an on-demand backup of live content in a site's collections.
 *
 *
 * By default, all of the site's collections are included in the backup. For a partial backup, specify which collections to include in the `backup.collections` parameter.
 *
 * The process of creating a backup takes time.
 * You can check whether a backup has completed successfully with [List Backups]().
 *
 * You can store up to 3 on-demand backups for each site.
 * If 3 on-demand backups already exist, the oldest existing on-demand backup for the site is deleted when a new one is created. Automated backups are not affected.
 */
export function createBackup(payload) {
    var _a = serializer(_createBackupRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_createBackupResponse, { _backup: _backup }).fromJSON;
    function __createBackup(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.data.v2.backup',
            method: 'POST',
            methodFqn: 'com.wixpress.dstore.api.backup.v2.BackupService.CreateBackup',
            url: resolveComWixpressDstoreApiBackupV2BackupServiceUrl({
                protoPath: '/v2/backups',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __createBackup.fromReq = fromReq;
    return __createBackup;
}
createBackup.__isAmbassador = true;
/**
 * Retrieves a list of all backups for a site.
 *
 * Results are sorted by requested date, with the newest first.
 *
 * You can use this endpoint to check whether a backup initiated with [Create Backup]() has been completed successfully.
 */
export function listBackups(payload) {
    var _a = serializer(_listBackupsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_listBackupsResponse, { _backup: _backup }).fromJSON;
    function __listBackups(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.data.v2.backup',
            method: 'GET',
            methodFqn: 'com.wixpress.dstore.api.backup.v2.BackupService.ListBackups',
            url: resolveComWixpressDstoreApiBackupV2BackupServiceUrl({
                protoPath: '/v2/backups',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __listBackups.fromReq = fromReq;
    return __listBackups;
}
listBackups.__isAmbassador = true;
/**
 * Restores all data from a backup.
 *
 * The process of restoring data from a backup takes time.
 * You can check whether your restoration has completed successfully with [List Restorations]().
 */
export function restoreBackup(payload) {
    var _a = serializer(_restoreBackupRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_restoreBackupResponse, {
        _backup: _backup,
        _restoration: _restoration,
    }).fromJSON;
    function __restoreBackup(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.data.v2.backup',
            method: 'POST',
            methodFqn: 'com.wixpress.dstore.api.backup.v2.BackupService.RestoreBackup',
            url: resolveComWixpressDstoreApiBackupV2BackupServiceUrl({
                protoPath: '/v2/backups/{backupId}/restore',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __restoreBackup.fromReq = fromReq;
    return __restoreBackup;
}
restoreBackup.__isAmbassador = true;
/**
 * Restores specific collections from a backup.
 *
 * The process of restoring data from a backup takes time.
 * You can check whether your restoration has completed successfully with [List Restorations]().
 */
export function restorePartialBackup(payload) {
    var _a = serializer(_restorePartialBackupRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_restoreBackupResponse, {
        _backup: _backup,
        _restoration: _restoration,
    }).fromJSON;
    function __restorePartialBackup(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.data.v2.backup',
            method: 'POST',
            methodFqn: 'com.wixpress.dstore.api.backup.v2.BackupService.RestorePartialBackup',
            url: resolveComWixpressDstoreApiBackupV2BackupServiceUrl({
                protoPath: '/v2/backups/{backupId}/partial-restore',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __restorePartialBackup.fromReq = fromReq;
    return __restorePartialBackup;
}
restorePartialBackup.__isAmbassador = true;
/**
 * Retrieves a list of all data restorations from backups.
 *
 * Results are sorted by requested date, with the newest first.
 *
 * You can use this endpoint to check whether a restoration initiated with [Restore Backup]() has been completed successfully.
 */
export function listRestorations(payload) {
    var _a = serializer(_listRestorationsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_listRestorationsResponse, {
        _backup: _backup,
        _restoration: _restoration,
    }).fromJSON;
    function __listRestorations(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.data.v2.backup',
            method: 'GET',
            methodFqn: 'com.wixpress.dstore.api.backup.v2.BackupService.ListRestorations',
            url: resolveComWixpressDstoreApiBackupV2BackupServiceUrl({
                protoPath: '/v2/backups/restorations',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __listRestorations.fromReq = fromReq;
    return __listRestorations;
}
listRestorations.__isAmbassador = true;
/**
 * Deletes a backup.
 *
 * The process of deleting a backup takes time.
 * You can check whether a backup has been deleted successfully with [List Backups]().
 */
export function deleteBackup(payload) {
    var _a = serializer(_deleteBackupRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_deleteBackupResponse, {}).fromJSON;
    function __deleteBackup(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.data.v2.backup',
            method: 'DELETE',
            methodFqn: 'com.wixpress.dstore.api.backup.v2.BackupService.DeleteBackup',
            url: resolveComWixpressDstoreApiBackupV2BackupServiceUrl({
                protoPath: '/v2/backups/{backupId}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __deleteBackup.fromReq = fromReq;
    return __deleteBackup;
}
deleteBackup.__isAmbassador = true;
/**
 * Cancels a backup.
 *
 * This endpoint is used to cancel a backup that was initiated with [Create Backup]() and is still underway.
 * The process of canceling a backup takes time. You can check whether your backup has been canceled successfully with [List Backups]().
 */
export function cancelBackup(payload) {
    var _a = serializer(_cancelBackupRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_cancelBackupResponse, {}).fromJSON;
    function __cancelBackup(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.data.v2.backup',
            method: 'POST',
            methodFqn: 'com.wixpress.dstore.api.backup.v2.BackupService.CancelBackup',
            url: resolveComWixpressDstoreApiBackupV2BackupServiceUrl({
                protoPath: '/v2/backups/cancel/{backupId}',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __cancelBackup.fromReq = fromReq;
    return __cancelBackup;
}
cancelBackup.__isAmbassador = true;
//# sourceMappingURL=http.impl.js.map